"use strict";
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OVERLAY_BACKGROUND_COLOR = exports.LOADING_DEFAULT_COLOR = exports.LOADING_INACTIVE_COLOR = exports.TABLE_SORT_ARROW_SELECTED_COLOR = exports.TABLE_SORT_ARROW_COLOR = exports.SIDENAV_SELECTED_BACKGROUND_COLOR = exports.SIDENAV_HOVERED_BACKGROUND_COLOR = exports.SIDENAV_FOREGROUND_COLOR = exports.SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = exports.SELECTABLE_BOX_SELECTED_BORDER_COLOR = exports.SELECTABLE_BOX_SHADOW_COLOR = exports.SELECTABLE_BOX_BORDER_COLOR = exports.PAGINATION_SELECTED_BORDER_COLOR = exports.PAGINATION_SELECTED_BACKGROUND_COLOR = exports.PAGINATION_HOVER_BACKGROUND_COLOR = exports.PAGINATION_ACTIVE_BACKGROUND_COLOR = exports.MODAL_SUCCESS_FOREGROUND_COLOR = exports.MODAL_SUCCESS_BACKGROUND_COLOR = exports.MODAL_UPGRADES_START_GRADIENT = exports.MODAL_UPGRADES_END_GRADIENT = exports.MODAL_UPGRADES_FOREGROUND_COLOR = exports.MODAL_HEADING_INVERTED_FOREGROUND_COLOR = exports.MODAL_HEADER_END_GRADIENT = exports.MODAL_HEADER_MIDDLE_GRADIENT = exports.MODAL_HEADER_START_GRADIENT = exports.MODAL_HEADER_FOREGROUND_COLOR = exports.MODAL_HEADER_BACKGROUND_COLOR = exports.MODAL_FOOTER_BACKGROUND_COLOR = exports.MODAL_DANGER_FOREGROUND_COLOR = exports.MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.MODAL_BACKGROUND_COLOR = exports.ICON_DEFAULT_COLOR = exports.HR_BORDER_COLOR = exports.FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = exports.FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = exports.FORM_TOGGLE_ICON_COLOR = exports.FORM_TOGGLE_HOVER_FOREGROUND_COLOR = exports.FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = exports.FORM_TOGGLE_BORDER_COLOR = exports.FORM_TOGGLE_HOVER_BACKGROUND_COLOR = exports.FORM_TOGGLE_BACKGROUND_COLOR = exports.FORM_STATIC_LABELS_COLOR = exports.FORM_STATIC_LABELS_BACKGROUND_COLOR = exports.FORM_PLACEHOLDER_COLOR = exports.FORM_DISABLED_BACKGROUND_COLOR = exports.FORM_DISABLED_COLOR = exports.FORM_COPYABLE_BACKGROUND_COLOR = exports.FORM_CONTROL_READONLY_BORDER_COLOR = exports.FORM_CONTROL_READONLY_BACKGROUND_COLOR = exports.FORM_CONTROL_BORDER_COLOR = exports.FORM_CONTROL_FOREGROUND_COLOR = exports.FORM_CONTROL_BACKGROUND_COLOR = exports.EDITOR_LAYOUT_SHADOW_COLOR = exports.TOOLBAR_DARK_FOREGROUND_COLOR = exports.TOOLBAR_DARK_BACKGROUND_COLOR = exports.DROPDOWN_CARET_COLOR = exports.DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = exports.DROPDOWN_SEARCH_BACKGROUND_COLOR = exports.DROPDOWN_SELECTED_BACKGROUND_COLOR = exports.DROPDOWN_BORDER_COLOR = exports.DROPDOWN_BACKGROUND_COLOR = exports.MENTION_LINK_HOVER_COLOR = exports.MENTION_LINK_ACTIVE_COLOR = exports.MENTION_LINK_COLOR = exports.DANGER_LINK_HOVER_COLOR = exports.DANGER_LINK_ACTIVE_COLOR = exports.DANGER_LINK_COLOR = exports.BRIGHT_LINK_ICON_COLOR = exports.BRIGHT_LINK_HOVER_COLOR = exports.BRIGHT_LINK_ACTIVE_COLOR = exports.BRIGHT_LINK_COLOR = exports.DARK_LINK_ICON_COLOR = exports.DARK_LINK_HOVER_COLOR = exports.DARK_LINK_ACTIVE_COLOR = exports.DARK_LINK_COLOR = exports.CONNECTED_STEP_UNSELECTED_COLOR = exports.CONNECTED_STEP_SELECTED_COLOR = exports.CODE_BLOCK_BACKGROUND_COLOR = exports.CODE_FOREGROUND_COLOR = exports.CODE_BACKGROUND_COLOR = exports.CHANGE_ARROW_DECREASE_COLOR = exports.CHANGE_ARROW_INCREASE_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = exports.FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = exports.CHEVRON_BACKGROUND_COLOR = exports.CARD_SHADOW_COLOR = exports.BUTTON_DISABLED_BACKGROUND_COLOR = exports.BASE_SHADOW_COLOR = exports.BASE_FONT_CONTRAST_COLOR = exports.BASE_BACKGROUND_COLOR_DARK = exports.BASE_BACKGROUND_COLOR_MEDIUM = exports.BASE_BACKGROUND_COLOR = exports.BASE_SELECTION_BACKGROUND_COLOR = exports.BASE_LINK_HOVER_COLOR = exports.BASE_LINK_ACTIVE_COLOR = exports.BASE_LINK_COLOR = exports.BASE_FONT_COLOR = void 0;
exports.DEVICE_FRAME_COLOR = exports.WIZARD_HEADER_BORDER_COLOR = exports.WIZARD_HEADER_BACKGROUND_COLOR = exports.TOOLTIP_LONGFORM_FOCUS_COLOR = exports.TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = exports.TOOLTIP_LONGFORM_BACKGROUND_COLOR = exports.TOOLTIP_DEFAULT_BACKGROUND_COLOR = exports.TOOLTIP_DANGER_BACKGROUND_COLOR = exports.TOOLTIP_FOREGROUND_COLOR = exports.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = exports.TAG_AVATAR_BORDER_COLOR = exports.TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = exports.TABLE_SORTABLE_HOVER_ICON_COLOR = exports.TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = exports.TABLE_ROW_HOVER_BACKGROUND_COLOR = exports.TABLE_HEADER_BACKGROUND_COLOR = exports.TABLE_BORDER_COLOR = exports.TABLE_BACKGROUND_COLOR = exports.PANEL_SHADOW_COLOR = exports.PANEL_FOOTER_BORDER_COLOR = exports.PANEL_FOOTER_BACKGROUND_COLOR = exports.PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = exports.OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = void 0;
var BASE_FONT_COLOR = '#33475b';
exports.BASE_FONT_COLOR = BASE_FONT_COLOR;
var BASE_LINK_COLOR = '#0091ae';
exports.BASE_LINK_COLOR = BASE_LINK_COLOR;
var BASE_LINK_ACTIVE_COLOR = '#7fd1de';
exports.BASE_LINK_ACTIVE_COLOR = BASE_LINK_ACTIVE_COLOR;
var BASE_LINK_HOVER_COLOR = '#007a8c';
exports.BASE_LINK_HOVER_COLOR = BASE_LINK_HOVER_COLOR;
var BASE_SELECTION_BACKGROUND_COLOR = '#eaf0f6';
exports.BASE_SELECTION_BACKGROUND_COLOR = BASE_SELECTION_BACKGROUND_COLOR;
var BASE_BACKGROUND_COLOR = '#ffffff';
exports.BASE_BACKGROUND_COLOR = BASE_BACKGROUND_COLOR;
var BASE_BACKGROUND_COLOR_MEDIUM = '#f5f8fa';
exports.BASE_BACKGROUND_COLOR_MEDIUM = BASE_BACKGROUND_COLOR_MEDIUM;
var BASE_BACKGROUND_COLOR_DARK = '#33475b';
exports.BASE_BACKGROUND_COLOR_DARK = BASE_BACKGROUND_COLOR_DARK;
var BASE_FONT_CONTRAST_COLOR = '#ffffff';
exports.BASE_FONT_CONTRAST_COLOR = BASE_FONT_CONTRAST_COLOR;
var BASE_SHADOW_COLOR = '#000000';
exports.BASE_SHADOW_COLOR = BASE_SHADOW_COLOR;
var BUTTON_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
exports.BUTTON_DISABLED_BACKGROUND_COLOR = BUTTON_DISABLED_BACKGROUND_COLOR;
var CARD_SHADOW_COLOR = '#2d3e50';
exports.CARD_SHADOW_COLOR = CARD_SHADOW_COLOR;
var CHEVRON_BACKGROUND_COLOR = '#eaf0f6';
exports.CHEVRON_BACKGROUND_COLOR = CHEVRON_BACKGROUND_COLOR;
var FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#425b76';
exports.FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR;
var FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = '#516f90';
exports.FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR;
var FLOATING_BUTTON_GROUP_ITEM_COLOR = '#ffffff';
exports.FLOATING_BUTTON_GROUP_ITEM_COLOR = FLOATING_BUTTON_GROUP_ITEM_COLOR;
var FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#516f90';
exports.FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR;
var FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#33475b';
exports.FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR;
var CHANGE_ARROW_INCREASE_COLOR = '#00bda5';
exports.CHANGE_ARROW_INCREASE_COLOR = CHANGE_ARROW_INCREASE_COLOR;
var CHANGE_ARROW_DECREASE_COLOR = '#f2545b';
exports.CHANGE_ARROW_DECREASE_COLOR = CHANGE_ARROW_DECREASE_COLOR;
var CODE_BACKGROUND_COLOR = '#eaf0f6';
exports.CODE_BACKGROUND_COLOR = CODE_BACKGROUND_COLOR;
var CODE_FOREGROUND_COLOR = '#33475b';
exports.CODE_FOREGROUND_COLOR = CODE_FOREGROUND_COLOR;
var CODE_BLOCK_BACKGROUND_COLOR = '#f5f8fa';
exports.CODE_BLOCK_BACKGROUND_COLOR = CODE_BLOCK_BACKGROUND_COLOR;
var CONNECTED_STEP_SELECTED_COLOR = '#ff7a59';
exports.CONNECTED_STEP_SELECTED_COLOR = CONNECTED_STEP_SELECTED_COLOR;
var CONNECTED_STEP_UNSELECTED_COLOR = '#cbd6e2';
exports.CONNECTED_STEP_UNSELECTED_COLOR = CONNECTED_STEP_UNSELECTED_COLOR;
var DARK_LINK_COLOR = '#ffffff';
exports.DARK_LINK_COLOR = DARK_LINK_COLOR;
var DARK_LINK_ACTIVE_COLOR = '#eaf0f6';
exports.DARK_LINK_ACTIVE_COLOR = DARK_LINK_ACTIVE_COLOR;
var DARK_LINK_HOVER_COLOR = '#7fd1de';
exports.DARK_LINK_HOVER_COLOR = DARK_LINK_HOVER_COLOR;
var DARK_LINK_ICON_COLOR = '#ffffff';
exports.DARK_LINK_ICON_COLOR = DARK_LINK_ICON_COLOR;
var BRIGHT_LINK_COLOR = '#33475b';
exports.BRIGHT_LINK_COLOR = BRIGHT_LINK_COLOR;
var BRIGHT_LINK_ACTIVE_COLOR = '#33475b';
exports.BRIGHT_LINK_ACTIVE_COLOR = BRIGHT_LINK_ACTIVE_COLOR;
var BRIGHT_LINK_HOVER_COLOR = '#33475b';
exports.BRIGHT_LINK_HOVER_COLOR = BRIGHT_LINK_HOVER_COLOR;
var BRIGHT_LINK_ICON_COLOR = '#425b76';
exports.BRIGHT_LINK_ICON_COLOR = BRIGHT_LINK_ICON_COLOR;
var DANGER_LINK_COLOR = '#f2545b';
exports.DANGER_LINK_COLOR = DANGER_LINK_COLOR;
var DANGER_LINK_ACTIVE_COLOR = '#d94c53';
exports.DANGER_LINK_ACTIVE_COLOR = DANGER_LINK_ACTIVE_COLOR;
var DANGER_LINK_HOVER_COLOR = '#d94c53';
exports.DANGER_LINK_HOVER_COLOR = DANGER_LINK_HOVER_COLOR;
var MENTION_LINK_COLOR = '#425b76';
exports.MENTION_LINK_COLOR = MENTION_LINK_COLOR;
var MENTION_LINK_ACTIVE_COLOR = '#33475b';
exports.MENTION_LINK_ACTIVE_COLOR = MENTION_LINK_ACTIVE_COLOR;
var MENTION_LINK_HOVER_COLOR = '#33475b';
exports.MENTION_LINK_HOVER_COLOR = MENTION_LINK_HOVER_COLOR;
var DROPDOWN_BACKGROUND_COLOR = '#ffffff';
exports.DROPDOWN_BACKGROUND_COLOR = DROPDOWN_BACKGROUND_COLOR;
var DROPDOWN_BORDER_COLOR = '#cbd6e2';
exports.DROPDOWN_BORDER_COLOR = DROPDOWN_BORDER_COLOR;
var DROPDOWN_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
exports.DROPDOWN_SELECTED_BACKGROUND_COLOR = DROPDOWN_SELECTED_BACKGROUND_COLOR;
var DROPDOWN_SEARCH_BACKGROUND_COLOR = '#ffffff';
exports.DROPDOWN_SEARCH_BACKGROUND_COLOR = DROPDOWN_SEARCH_BACKGROUND_COLOR;
var DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = '#eaf0f6';
exports.DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR;
var DROPDOWN_CARET_COLOR = '#00a4bd';
exports.DROPDOWN_CARET_COLOR = DROPDOWN_CARET_COLOR;
var TOOLBAR_DARK_BACKGROUND_COLOR = '#253342';
exports.TOOLBAR_DARK_BACKGROUND_COLOR = TOOLBAR_DARK_BACKGROUND_COLOR;
var TOOLBAR_DARK_FOREGROUND_COLOR = '#ffffff';
exports.TOOLBAR_DARK_FOREGROUND_COLOR = TOOLBAR_DARK_FOREGROUND_COLOR;
var EDITOR_LAYOUT_SHADOW_COLOR = '#516f90';
exports.EDITOR_LAYOUT_SHADOW_COLOR = EDITOR_LAYOUT_SHADOW_COLOR;
var FORM_CONTROL_BACKGROUND_COLOR = '#f5f8fa';
exports.FORM_CONTROL_BACKGROUND_COLOR = FORM_CONTROL_BACKGROUND_COLOR;
var FORM_CONTROL_FOREGROUND_COLOR = '#33475b';
exports.FORM_CONTROL_FOREGROUND_COLOR = FORM_CONTROL_FOREGROUND_COLOR;
var FORM_CONTROL_BORDER_COLOR = '#cbd6e2';
exports.FORM_CONTROL_BORDER_COLOR = FORM_CONTROL_BORDER_COLOR;
var FORM_CONTROL_READONLY_BACKGROUND_COLOR = '#eaf0f6';
exports.FORM_CONTROL_READONLY_BACKGROUND_COLOR = FORM_CONTROL_READONLY_BACKGROUND_COLOR;
var FORM_CONTROL_READONLY_BORDER_COLOR = '#eaf0f6';
exports.FORM_CONTROL_READONLY_BORDER_COLOR = FORM_CONTROL_READONLY_BORDER_COLOR;
var FORM_COPYABLE_BACKGROUND_COLOR = '#ffffff';
exports.FORM_COPYABLE_BACKGROUND_COLOR = FORM_COPYABLE_BACKGROUND_COLOR;
var FORM_DISABLED_COLOR = '#cbd6e2';
exports.FORM_DISABLED_COLOR = FORM_DISABLED_COLOR;
var FORM_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
exports.FORM_DISABLED_BACKGROUND_COLOR = FORM_DISABLED_BACKGROUND_COLOR;
var FORM_PLACEHOLDER_COLOR = '#7c98b6';
exports.FORM_PLACEHOLDER_COLOR = FORM_PLACEHOLDER_COLOR;
var FORM_STATIC_LABELS_BACKGROUND_COLOR = '#eaf0f6';
exports.FORM_STATIC_LABELS_BACKGROUND_COLOR = FORM_STATIC_LABELS_BACKGROUND_COLOR;
var FORM_STATIC_LABELS_COLOR = '#7c98b6';
exports.FORM_STATIC_LABELS_COLOR = FORM_STATIC_LABELS_COLOR;
var FORM_TOGGLE_BACKGROUND_COLOR = '#ffffff';
exports.FORM_TOGGLE_BACKGROUND_COLOR = FORM_TOGGLE_BACKGROUND_COLOR;
var FORM_TOGGLE_HOVER_BACKGROUND_COLOR = '#eaf0f6';
exports.FORM_TOGGLE_HOVER_BACKGROUND_COLOR = FORM_TOGGLE_HOVER_BACKGROUND_COLOR;
var FORM_TOGGLE_BORDER_COLOR = '#cbd6e2';
exports.FORM_TOGGLE_BORDER_COLOR = FORM_TOGGLE_BORDER_COLOR;
var FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = '#99acc2';
exports.FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = FORM_TOGGLE_DISABLED_FOREGROUND_COLOR;
var FORM_TOGGLE_HOVER_FOREGROUND_COLOR = '#0091ae';
exports.FORM_TOGGLE_HOVER_FOREGROUND_COLOR = FORM_TOGGLE_HOVER_FOREGROUND_COLOR;
var FORM_TOGGLE_ICON_COLOR = '#99acc2';
exports.FORM_TOGGLE_ICON_COLOR = FORM_TOGGLE_ICON_COLOR;
var FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = '#ffffff';
exports.FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = FORM_TOGGLE_SELECTED_BACKGROUND_COLOR;
var FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = '#00a4bd';
exports.FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = FORM_TOGGLE_SELECTED_FOREGROUND_COLOR;
var HR_BORDER_COLOR = '#dfe3eb';
exports.HR_BORDER_COLOR = HR_BORDER_COLOR;
var ICON_DEFAULT_COLOR = '#7c98b6';
exports.ICON_DEFAULT_COLOR = ICON_DEFAULT_COLOR;
var MODAL_BACKGROUND_COLOR = '#ffffff';
exports.MODAL_BACKGROUND_COLOR = MODAL_BACKGROUND_COLOR;
var MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = '#99acc2';
exports.MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = MODAL_CLOSE_BUTTON_FOREGROUND_COLOR;
var MODAL_DANGER_FOREGROUND_COLOR = '#ffffff';
exports.MODAL_DANGER_FOREGROUND_COLOR = MODAL_DANGER_FOREGROUND_COLOR;
var MODAL_FOOTER_BACKGROUND_COLOR = '#ffffff';
exports.MODAL_FOOTER_BACKGROUND_COLOR = MODAL_FOOTER_BACKGROUND_COLOR;
var MODAL_HEADER_BACKGROUND_COLOR = '#00bda5';
exports.MODAL_HEADER_BACKGROUND_COLOR = MODAL_HEADER_BACKGROUND_COLOR;
var MODAL_HEADER_FOREGROUND_COLOR = '#ffffff';
exports.MODAL_HEADER_FOREGROUND_COLOR = MODAL_HEADER_FOREGROUND_COLOR;
var MODAL_HEADER_START_GRADIENT = '#00a4bd';
exports.MODAL_HEADER_START_GRADIENT = MODAL_HEADER_START_GRADIENT;
var MODAL_HEADER_MIDDLE_GRADIENT = '#00afb2';
exports.MODAL_HEADER_MIDDLE_GRADIENT = MODAL_HEADER_MIDDLE_GRADIENT;
var MODAL_HEADER_END_GRADIENT = '#00bda5';
exports.MODAL_HEADER_END_GRADIENT = MODAL_HEADER_END_GRADIENT;
var MODAL_HEADING_INVERTED_FOREGROUND_COLOR = '#ffffff';
exports.MODAL_HEADING_INVERTED_FOREGROUND_COLOR = MODAL_HEADING_INVERTED_FOREGROUND_COLOR;
var MODAL_UPGRADES_FOREGROUND_COLOR = '#ffffff';
exports.MODAL_UPGRADES_FOREGROUND_COLOR = MODAL_UPGRADES_FOREGROUND_COLOR;
var MODAL_UPGRADES_END_GRADIENT = '#ff8f59';
exports.MODAL_UPGRADES_END_GRADIENT = MODAL_UPGRADES_END_GRADIENT;
var MODAL_UPGRADES_START_GRADIENT = '#ff7a59';
exports.MODAL_UPGRADES_START_GRADIENT = MODAL_UPGRADES_START_GRADIENT;
var MODAL_SUCCESS_BACKGROUND_COLOR = '#00bda5';
exports.MODAL_SUCCESS_BACKGROUND_COLOR = MODAL_SUCCESS_BACKGROUND_COLOR;
var MODAL_SUCCESS_FOREGROUND_COLOR = '#ffffff';
exports.MODAL_SUCCESS_FOREGROUND_COLOR = MODAL_SUCCESS_FOREGROUND_COLOR;
var PAGINATION_ACTIVE_BACKGROUND_COLOR = '#cbd6e2';
exports.PAGINATION_ACTIVE_BACKGROUND_COLOR = PAGINATION_ACTIVE_BACKGROUND_COLOR;
var PAGINATION_HOVER_BACKGROUND_COLOR = '#eaf0f6';
exports.PAGINATION_HOVER_BACKGROUND_COLOR = PAGINATION_HOVER_BACKGROUND_COLOR;
var PAGINATION_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
exports.PAGINATION_SELECTED_BACKGROUND_COLOR = PAGINATION_SELECTED_BACKGROUND_COLOR;
var PAGINATION_SELECTED_BORDER_COLOR = '#7fd1de';
exports.PAGINATION_SELECTED_BORDER_COLOR = PAGINATION_SELECTED_BORDER_COLOR;
var SELECTABLE_BOX_BORDER_COLOR = '#7fd1de';
exports.SELECTABLE_BOX_BORDER_COLOR = SELECTABLE_BOX_BORDER_COLOR;
var SELECTABLE_BOX_SHADOW_COLOR = 'rgba(0, 163, 189, .3)';
exports.SELECTABLE_BOX_SHADOW_COLOR = SELECTABLE_BOX_SHADOW_COLOR;
var SELECTABLE_BOX_SELECTED_BORDER_COLOR = '#00a4bd';
exports.SELECTABLE_BOX_SELECTED_BORDER_COLOR = SELECTABLE_BOX_SELECTED_BORDER_COLOR;
var SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
exports.SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR;
var SIDENAV_FOREGROUND_COLOR = '#33475b';
exports.SIDENAV_FOREGROUND_COLOR = SIDENAV_FOREGROUND_COLOR;
var SIDENAV_HOVERED_BACKGROUND_COLOR = '#eaf0f6';
exports.SIDENAV_HOVERED_BACKGROUND_COLOR = SIDENAV_HOVERED_BACKGROUND_COLOR;
var SIDENAV_SELECTED_BACKGROUND_COLOR = '#eaf0f6';
exports.SIDENAV_SELECTED_BACKGROUND_COLOR = SIDENAV_SELECTED_BACKGROUND_COLOR;
var TABLE_SORT_ARROW_COLOR = '#cbd6e2';
exports.TABLE_SORT_ARROW_COLOR = TABLE_SORT_ARROW_COLOR;
var TABLE_SORT_ARROW_SELECTED_COLOR = '#00a4bd';
exports.TABLE_SORT_ARROW_SELECTED_COLOR = TABLE_SORT_ARROW_SELECTED_COLOR;
var LOADING_INACTIVE_COLOR = '#cbd6e2';
exports.LOADING_INACTIVE_COLOR = LOADING_INACTIVE_COLOR;
var LOADING_DEFAULT_COLOR = '#00a4bd';
exports.LOADING_DEFAULT_COLOR = LOADING_DEFAULT_COLOR;
var OVERLAY_BACKGROUND_COLOR = '#2d3e50';
exports.OVERLAY_BACKGROUND_COLOR = OVERLAY_BACKGROUND_COLOR;
var OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = 'rgba(#2d3e50, .79)';
exports.OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = OVERLAY_BACKGROUND_COLOR_TRANSLUCENT;
var PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = '#ffffff';
exports.PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = PANEL_CLOSE_BUTTON_FOREGROUND_COLOR;
var PANEL_FOOTER_BACKGROUND_COLOR = '#f5f8fa';
exports.PANEL_FOOTER_BACKGROUND_COLOR = PANEL_FOOTER_BACKGROUND_COLOR;
var PANEL_FOOTER_BORDER_COLOR = '#cbd6e2';
exports.PANEL_FOOTER_BORDER_COLOR = PANEL_FOOTER_BORDER_COLOR;
var PANEL_SHADOW_COLOR = 'rgba(#425b76, .21)';
exports.PANEL_SHADOW_COLOR = PANEL_SHADOW_COLOR;
var TABLE_BACKGROUND_COLOR = '#ffffff';
exports.TABLE_BACKGROUND_COLOR = TABLE_BACKGROUND_COLOR;
var TABLE_BORDER_COLOR = '#dfe3eb';
exports.TABLE_BORDER_COLOR = TABLE_BORDER_COLOR;
var TABLE_HEADER_BACKGROUND_COLOR = '#f5f8fa';
exports.TABLE_HEADER_BACKGROUND_COLOR = TABLE_HEADER_BACKGROUND_COLOR;
var TABLE_ROW_HOVER_BACKGROUND_COLOR = '#f5f8fa';
exports.TABLE_ROW_HOVER_BACKGROUND_COLOR = TABLE_ROW_HOVER_BACKGROUND_COLOR;
var TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = '#e5f5f8';
exports.TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = TABLE_SORTABLE_HOVER_BACKGROUND_COLOR;
var TABLE_SORTABLE_HOVER_ICON_COLOR = '#7c98b6';
exports.TABLE_SORTABLE_HOVER_ICON_COLOR = TABLE_SORTABLE_HOVER_ICON_COLOR;
var TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = '#eaf0f6';
exports.TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = TABLE_SORTABLE_SORTED_BACKGROUND_COLOR;
var TAG_AVATAR_BORDER_COLOR = '#7fd1de';
exports.TAG_AVATAR_BORDER_COLOR = TAG_AVATAR_BORDER_COLOR;
var TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = '#cbd6e2';
exports.TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = TEMPLATE_SECTION_DIVIDER_BORDER_COLOR;
var TOOLTIP_FOREGROUND_COLOR = '#ffffff';
exports.TOOLTIP_FOREGROUND_COLOR = TOOLTIP_FOREGROUND_COLOR;
var TOOLTIP_DANGER_BACKGROUND_COLOR = '#f2545b';
exports.TOOLTIP_DANGER_BACKGROUND_COLOR = TOOLTIP_DANGER_BACKGROUND_COLOR;
var TOOLTIP_DEFAULT_BACKGROUND_COLOR = '#425b76';
exports.TOOLTIP_DEFAULT_BACKGROUND_COLOR = TOOLTIP_DEFAULT_BACKGROUND_COLOR;
var TOOLTIP_LONGFORM_BACKGROUND_COLOR = '#ffffff';
exports.TOOLTIP_LONGFORM_BACKGROUND_COLOR = TOOLTIP_LONGFORM_BACKGROUND_COLOR;
var TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = '#0091ae';
exports.TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR;
var TOOLTIP_LONGFORM_FOCUS_COLOR = '#00a4bd';
exports.TOOLTIP_LONGFORM_FOCUS_COLOR = TOOLTIP_LONGFORM_FOCUS_COLOR;
var WIZARD_HEADER_BACKGROUND_COLOR = '#ffffff';
exports.WIZARD_HEADER_BACKGROUND_COLOR = WIZARD_HEADER_BACKGROUND_COLOR;
var WIZARD_HEADER_BORDER_COLOR = '#cbd6e2';
exports.WIZARD_HEADER_BORDER_COLOR = WIZARD_HEADER_BORDER_COLOR;
var DEVICE_FRAME_COLOR = '#7c98b6';
exports.DEVICE_FRAME_COLOR = DEVICE_FRAME_COLOR;